import React, {useMemo, useState} from "react";
import {Alert, Button, Card, Col, Divider, Empty, Row, Space, Typography, Upload} from "antd";

import {BookOutlined, CloudUploadOutlined, DownloadOutlined, FileExcelOutlined} from "@ant-design/icons";
import AdminLayout from "@/components/layout/admin/adminLayout";
import {URLS} from "@/lib/urls";
import {useApiAminCreateImport} from "@/api/import";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {useNavigate} from "react-router-dom";

const {Title, Text, Paragraph} = Typography;
const {Dragger} = Upload;

const IMPORT_TYPES = [
    {
        key: "lessons",
        title: "درس‌ها",
        icon: <BookOutlined/>,
        description:
            "برای واردسازی گروهی درس‌ها از فایل اکسل استفاده کنید.",
        sampleUrl: "/assets/import/lesson_import_example.xlsx",
        rules: [
            "ستون semester_code الزامی است",
            "ستون topic_code الزامی است",
            "ستون classroom_id الزامی است",
            "ستون status الزامی است",
            "ستون gender الزامی است",
            "ستون privacy الزامی است",
            "ستون maxperson الزامی است",

            "از فایل نمونه استفاده کنید و مقادیر را به صورت دقیق ثبت کنید."
        ]
    },
    // {
    //     key: "users",
    //     title: "کاربران ( به زودی ) ",
    //     icon: <UserOutlined />,
    //     description:
    //         "واردسازی کاربران سیستم از طریق فایل اکسل.",
    //     sampleUrl: "/samples/users.xlsx",
    //     rules: [
    //         "شماره موبایل تکراری نباشد.",
    //         "نام و نام خانوادگی الزامی است."
    //     ]
    // },
    // {
    //     key: "topics",
    //     title: "موضوعات",
    //     icon: <TagsOutlined />,
    //     description:
    //         "واردسازی موضوعات آموزشی.",
    //     sampleUrl: "/samples/topics.xlsx",
    //     rules: [
    //         "عنوان موضوع الزامی است."
    //     ]
    // }
];

function AdminImportCreate() {

    const [selectedType, setSelectedType] = useState(null);
    const [fileList, setFileList] = useState([]);
    const navigate = useNavigate();

    const currentImport = useMemo(() => {
        return IMPORT_TYPES.find(
            item => item.key === selectedType
        );
    }, [selectedType]);

    const {mutate: createImport, isPending} = useApiAminCreateImport();

    const handleSubmit = () => {

        if (!selectedType) {
            return;
        }

        if (!fileList.length) {
            return;
        }

        const formData = new FormData();

        formData.append('type', selectedType);

        formData.append(
            'file',
            fileList[0].originFileObj
        );


        createImport(formData,
            {
                onSuccess: (result) => {
                    ApiHandleSuccessMessage(result);
                    navigate(URLS.admin.import.dashboard)
                },
                onError: (err) => {
                    ApiHandleErrorMessage(err);
                }

            })


    };

    return (
        <AdminLayout pageTitle={'وارد سازی داده انبوه'} backTo={URLS.admin.import.dashboard}>


            <Card
                title="انتخاب نوع واردسازی"
                style={{
                    marginBottom: 24
                }}
            >
                <Row gutter={[16, 16]}>
                    {IMPORT_TYPES.map(item => {

                        const active =
                            item.key === selectedType;

                        return (
                            <Col
                                xs={24}
                                md={4}
                                key={item.key}
                            >
                                <Card
                                    hoverable
                                    onClick={() =>
                                        setSelectedType(
                                            item.key
                                        )
                                    }
                                    styles={{
                                        body: {
                                            textAlign:
                                                "center"
                                        }
                                    }}
                                    style={{
                                        border: active
                                            ? "2px solid #1677ff"
                                            : undefined
                                    }}
                                >
                                    <Space
                                        direction="vertical"
                                        size="middle"
                                    >
                                        <div
                                            style={{
                                                fontSize: 40,
                                                color:
                                                    "#1677ff"
                                            }}
                                        >
                                            {item.icon}
                                        </div>

                                        <Title
                                            level={5}
                                            style={{
                                                margin: 0
                                            }}
                                        >
                                            {item.title}
                                        </Title>

                                        <Text
                                            type="secondary"
                                        >
                                            {
                                                item.description
                                            }
                                        </Text>
                                    </Space>
                                </Card>
                            </Col>
                        );
                    })}
                </Row>
            </Card>

            {!currentImport && (
                <Card>
                    <Empty
                        description="یک نوع واردسازی انتخاب کنید"
                    />
                </Card>
            )}

            {currentImport && (
                <>
                    <Card
                        title={`راهنمای واردسازی ${currentImport.title}`}
                        style={{
                            marginBottom: 24
                        }}
                    >
                        <Space
                            direction="vertical"
                            size="large"
                            style={{
                                width: "100%"
                            }}
                        >
                            <Alert
                                showIcon
                                type="info"
                                message={
                                    currentImport.description
                                }
                            />

                            <div>
                                <Title level={5}>
                                    قوانین فایل
                                </Title>

                                <ul>
                                    {currentImport.rules.map(
                                        rule => (
                                            <li key={rule}>
                                                {rule}
                                            </li>
                                        )
                                    )}
                                </ul>
                            </div>

                            <Button
                                icon={
                                    <DownloadOutlined/>
                                }
                                href={
                                    currentImport.sampleUrl
                                }
                                target="_blank"
                            >
                                دانلود فایل نمونه
                            </Button>
                        </Space>
                    </Card>

                    <Card
                        title="بارگذاری فایل"
                        style={{
                            marginBottom: 24
                        }}
                    >
                        <Dragger
                            accept=".xlsx,.xls"
                            multiple={false}
                            beforeUpload={() => false}
                            fileList={fileList}
                            onChange={({fileList}) =>
                                setFileList(fileList)
                            }
                        >
                            <p
                                style={{
                                    fontSize: 48
                                }}
                            >
                                <CloudUploadOutlined/>
                            </p>

                            <p>
                                فایل اکسل را اینجا
                                رها کنید یا کلیک کنید
                            </p>

                            <Text type="secondary">
                                فقط فایل‌های Excel
                                مجاز هستند
                            </Text>
                        </Dragger>

                        {fileList.length > 0 && (
                            <>
                                <Divider/>

                                <Space>
                                    <FileExcelOutlined
                                        style={{
                                            color:
                                                "#52c41a",
                                            fontSize: 20
                                        }}
                                    />

                                    <Text strong>
                                        {
                                            fileList[0]
                                                .name
                                        }
                                    </Text>
                                </Space>
                            </>
                        )}
                    </Card>

                    <Card>
                        <Space>
                            <Button
                                size="large"
                                onClick={() => {
                                    setFileList([]);
                                }}
                            >
                                انصراف
                            </Button>

                            <Button
                                type="primary"
                                size="large"
                                disabled={
                                    !fileList.length
                                }
                                onClick={
                                    handleSubmit
                                }
                            >
                                شروع واردسازی
                            </Button>
                        </Space>
                    </Card>
                </>
            )}

        </AdminLayout>
    );
}

export default AdminImportCreate;